import { createFileRoute } from "@tanstack/react-router";
import { EditCommandePage } from "@/features/achats/components/commandes/EditCommandePage";

export const Route = createFileRoute("/_app/achats/commandes/$id/edit")({
  staticData: {
    title: "Modifier commande",
    showInBreadcrumb: true,
  },
  component: EditCommandePage,
});
